<script>
    import { onMount } from "svelte";

    import { v4 } from "uuid";

    import { defaultFilters } from "../../stores";
    import { get } from "svelte/store";
    import { cacheDefaultFilters } from "../../Utils/utilCache.svelte";

    export let filter = {};
    export let filterPropertyName = "";
    export let onChangeFunc = () => {};
    export let title = "Pre-Defined Filters";
    export let id = "";
    export let isLong = false;
    export let titleClass = "";
    export let inputClass = "";

    const uuid = v4();

    $: inputId = id ? id : uuid;

    let defaultClass = isLong
        ? "input-sm w-48 bg-gray-200"
        : "input-sm w-32 bg-gray-200";

    let defaultTitleClass = "text-[11px] font-[500]";

    let filterOptions = [];

    onMount(() => {
        setTimeout(async () => {
            if (get(defaultFilters) && get(defaultFilters).userFilter)
                filterOptions = get(defaultFilters).userFilter;
            else {
                await cacheDefaultFilters();
                if (get(defaultFilters) && get(defaultFilters).userFilter)
                    filterOptions = get(defaultFilters).userFilter;
            }
        }, 500);
    });
</script>

{#if filterOptions.length}
    <div class="flex flex-col">
        <p class={defaultTitleClass + " " + titleClass}>{title}</p>

        <select
            id={inputId}
            bind:value={filter[filterPropertyName]}
            on:change={onChangeFunc}
            class={defaultClass + " " + inputClass}
        >
            <option value="" selected={!filter[filterPropertyName]}></option>
            {#each filterOptions as { filter, name }}
                <option value={filter}>{name}</option>
            {/each}
        </select>
    </div>
{/if}

<style>
    p {
        color: #6f726c;
    }

    select {
        outline: 0;
        border-width: 0 0 2px;
        border-color: #818e9b;
    }

    select:focus {
        border-color: #270053;
    }
</style>
